//'use strict';

class FormCheck {
    constructor() {
      this.errorClass = 'has-error';
      this.msgError = [];
      this.uniqueMsg = [];
    }

    checkParams(params, field) {
      if(params.length<2) { // un parametre
        this[params](field);
      }
      else {
        var that = this;
        params.forEach(function(p) {
            that[p](field);
        });
      }
    }

    checkParamsDNI(country, type){
      if (country == 'CL')
        this.checkParams(['checkNIFChile'], '#appointment_dni');
      else if (country == 'ES')
      {
        if(type == 0)
           this.checkParams(['checkDNISpain'], '#appointment_dni');
        else
           this.checkParams(['checkCIFSpain'], '#appointment_dni');
      }
    }

    checkMandatory(field) {
      var strr = $.trim($(field).val());
      if(!($(field).val() !== '' && strr.length > 0)) {
        this.paintError(field, true, errorsTranslations['MANDATORY_FIELD']);
        return false;
      }
    }
    
    checkScript(field) {
      var regex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
      var value = $.trim($(field).val().replace(regex, ''));
      if (value === '' && $(field).val()!='') {
        this.paintError(field, true, errorsTranslations['00007_SCRIPTS_NOT_ALLOWED']);
        return true;
      } 
    }

    checkSelect(field) {
      if($(field).val()!='' && $(field).val()){
        $('.select2-container .select2-selection--single').css('border','1px solid #ccc');
      }else{
        $('.select2-container .select2-selection--single').css('border','1px solid #d9534f');
        this.paintError(field, true, errorsTranslations['MANDATORY_FIELD']);
        return true;
      }
    }

    checkFieldNospaces(field) {
      if($(field).val()!='' && $(field).val().indexOf(" ")==-1 ){
          this.paintError(field, true, errorsTranslations['INVALID_FORMAT']);
          return true;
      }
    }

    checkOnlyWhiteSpaces(field) {
      if($(field).val()!='' && $.trim($(field).val()).length==0) {
          this.paintError(field, true, errorsTranslations['INVALID_FORMAT']);
          return true;
      }
    }

    checkNoSymbols(field) {
      var pattern = /[!¬¡¿?"·@$%&(){}+*_€=#|$~<>]+/g;
      var value = $(field).val(); 
      var i = 0;
      if ((value != '') && (pattern.test(value))) {
        i = 1;
      }
      if (i === 0) { 
        return false;
      }
      this.paintError(field, true, errorsTranslations['SYMBOLS_ERROR']);
    }

    checkNoNumber(field) {
      var pattern = /[0-9]+/g;
      var value = $.trim($(field).val().replace(pattern, ''));
      $(field).val(value);
      return false;
    }

    checkPhone(field) {
      var pattern = /^([a-zA-Z0-9 ().+\-])+$/g;
      var i = 0;
      if ($(field).val() !== '' && !pattern.test($(field).val())) {
        i = 1;
      }
      if (i != 0) {
        this.paintError(field, true, errorsTranslations['SMS_PROVIDER_ERROR:02029_PHONE_NUMBER_INVALID_FORMAT']);
        return true;
      }
    }

    checkNum(field) {
      if ($(field).val() !== '' && !$.isNumeric( $(field).val())) {
        this.paintError(field, true, errorsTranslations['INVALID_FORMAT']);
        return true;
      }
    }

    checkAcentos(field){
      var ar = new Array('á','é','í','ó','ú','à','è','ì','ò','ù', 'Á','É','Í','Ó','Ú','À','È','Ì','Ò','Ù','ä','ë','ï','ö','ü')
      var found = 0;
      var i;
      for(i=0; i<=ar.length; i++){
        if($(field).val().indexOf(ar[i])>0){
          this.paintError(field, true, errorsTranslations['INVALID_FORMAT']);
          return true;
        }
      }
      return false;
    }

    checkMail(field) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if ($(field).val() !== '' && (!re.test($(field).val()) || this.checkAcentos(field) == 1)) {
        this.paintError(field, true, errorsTranslations['INVALID_FORMAT']);
        return true;
      }
    }

    checkDNISpain(field) {
      var dni = $(field).val();
      dni = dni.toUpperCase();
      var validatorES = { 0:'T', 1:'R', 2:'W', 3:'A', 4:'G', 5:'M', 6:'Y', 7:'F', 8:'P', 9:'D', 10:'X', 11:'B', 12:'N', 13:'J', 14:'Z', 15:'S', 16:'Q', 17:'V', 18:'H', 19:'L', 20:'C', 21:'K', 22:'E' };
      var regexDNI = /^(([0-9]{8})([-]?)([A-Z]))$/;
      var regexNIE = /^(([X-Z])|([LM])){1}([-]?)((\d){7,8})([-]?)([A-Z]{1})$/;
      if ((dni.length == 9) || (dni.length == 10)) {
          if(regexDNI.test(dni)) {
              var dniLetter = dni.slice(dni.length - 1);
              var dniNumber = dni.slice(0, -1);
              var mod = (parseInt(dniNumber) % 23);
              if(validatorES[mod] == dniLetter) {
                  return false;
              } 
          } else if(regexNIE.test(dni)) {
              if((dni[0] == 'X') || (dni[0] == 'Y') || (dni[0] == 'Z')) {
                  if(dni[0] == 'X') {
                      dni = dni.replace('X',0);
                  } else if(dni[0] == 'Y') {
                      dni = dni.replace('Y',1);
                  } else {
                      dni = dni.replace('Z',2);
                  }
                  var dniLetter = dni.slice(dni.length - 1);
                  var dniNumber = dni.slice(0, -1);
                  var mod = (parseInt(dniNumber) % 23);
                  if(validatorES[mod] == dniLetter) {
                      return false;
                  } 
              } 
          }
      } 
      this.paintError(field, true, errorsTranslations['INVALID_FORMAT']);
      return true;
    }

    checkCIFSpain(field) {
      var cif = $(field).val();
      cif = cif.toUpperCase();
      var regexCIF = /^([ABCDEFGHJKLMNPQRSUVW])(\d{7})([-]?)([0-9A-J])$/;
      var table = ['J', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'];
      if(cif.length==9) {
          if(regexCIF.test(cif)) {
              var evenSum = 0; //even
              var oddSum = 0; //odd
              evenSum = parseInt(cif.substring(2, 3)) + parseInt(cif.substring(4, 5)) + parseInt(cif.substring(6, 7));
              var i = 1;
              while (i <= 8) {
                  let p = 2 * parseInt(cif.substring(i, i + 1));
                  oddSum += (function() {
                      if (p > 9) {
                          p = p.toString();
                          return parseInt(parseInt(p.charAt(0))+parseInt(p.charAt(1)));
                      } else {
                          return parseInt(p);
                      }
                  })();
                  i+=2;
              }
              var totalSum = evenSum + oddSum;
              var digitControl = totalSum % 10;
              digitControl = 10 - digitControl;
              if (digitControl == 10) {
                  digitControl = 0;
              }
              if((table[digitControl] == cif[8]) || (parseInt(cif[8]) == digitControl)) {
                  return false;
              } 
          }
      }
      this.paintError(field, true, errorsTranslations['INVALID_FORMAT']);
      return true;
    }   

    checkNIFChile(field)
    {
      var rutCompleto = $(field).val();
      var Fn = {
        validaRut : function (rutCompleto) {
          if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test( rutCompleto ))
            return false;
          var tmp 	= rutCompleto.split('-');
          var digv	= tmp[1]; 
          var rut 	= tmp[0];
          if ( digv == 'K' ) digv = 'k' ;
          return (Fn.dv(rut) == digv );
        },
        dv : function(T){
          var M=0,S=1;
          for(;T;T=Math.floor(T/10))
            S=(S+T%10*(9-M++%6))%11;
          return S?S-1:'k';
        }
      }
      if (Fn.validaRut(rutCompleto))
        return false;
      else {  
        this.paintError(field, true, codErr['INVALID_FORMAT']);
        return true;
      }
    }

    //just paint
    checkMultiple(fields, errorMsg) {
      this.paintError(fields, true, errorMsg);
      return false;
    } 

    checkPlate(field) {
      let pattern = /[!¬¡¿?"'`´^¨,@$%&(){}\[\]\\\/+*_€=#|~<>]+/g;
      let value = $.trim($(field).val().replace(pattern, ''));
      $(field).val(value);
      return false;
    }

    insertError(field, errorMsg) {
      this.paintError($(field).parent(), true, errorMsg);
    }

    paintError(field, isError, errorMsg) {
      if(Array.isArray(field)) {
        var that = this;
        field.forEach(function(item) {
          $(item).parent().addClass(that.errorClass);
        });
        this.msgError.push({error: errorMsg, field: field });
      } else {
        if (isError && !$(field).parent().hasClass(this.errorClass)) {
          if(field == '#appointment_tlf') {
            $(field).parent().parent().addClass(this.errorClass);
          } else {
            if (field != '#appointment_vehicle_brand'){
              $(field).parent().addClass(this.errorClass);
            }
          }
          this.msgError.push({error: errorMsg, field: field });
        }
      }
    }

    getMsgError() {
      let that = this;
      $.each(this.msgError, function(i, el){
        if(Array.isArray(el.field) && el.field.length>=2) {
          var error = el.error;
          el.field.forEach(function(item) {
            that.searchInMessage(error, item);
          });
        } else {
          that.searchInMessage(el.error, el.field);
        }
      });
      return this.uniqueMsg;
    }

    searchInMessage(error, field) {
      var fieldName = $(field).parents('.form-group').find('label').text();
      if(field == '#appointment_reason_msg') {
        fieldName = $(field).parent().find('label').text();
      }
      if(this.uniqueMsg.length>0) {
        let that = this;
        this.indexFound = null;
        $.each(this.uniqueMsg, function(i,el) {
          if(error == el.error) {
              that.indexFound = i;
              return;
          }
        });
        if(this.indexFound != null) {
          this.uniqueMsg[this.indexFound].fields += ", " +fieldName;
        }
        else {
          this.uniqueMsg.push({error: error, fields: fieldName});
        }
      }
      else {
        this.uniqueMsg.push({error: error, fields: fieldName});
      }
  }

}

export { FormCheck }